/* © NXAPP Limited */
import TemplatesContent from './TemplatesContent'

// Global shared templates view (campaign_id = null)
export default function TemplatesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Templates</h1>
        <p className="text-sm text-gray-500 mt-1">Shared templates — reusable across all campaigns</p>
      </div>
      <TemplatesContent campaignId={null} />
    </div>
  )
}
